export default {
    title: "Influx Studios",
    titleTemplate: "%s | Influx Studios",
};
